import React from "react";
import PropTypes from "prop-types";

import CustomerSelect from "../common/CustomerSelect";
import DepartmentSelect from "../common/DepartmentSelect";
import CallTypeSelect from "../common/CallTypeSelect";
import ProjectSelect from "../common/ProjectSelect";
import UserSelect from "../common/UserSelect";

const ApprovalFilters = ({ children, onChange }) => (
  <div className="approval-filters">
    <CustomerSelect onChange={onChange("customers")} />
    <ProjectSelect onChange={onChange("projects")} />
    <DepartmentSelect isMulti onChange={onChange("departments")} />
    <CallTypeSelect isMulti onChange={onChange("callTypes")} />
    <UserSelect isMulti onChange={onChange("users")} />
    <input
      type="date"
      onChange={(e) => onChange("startDate")(e.target.value)}
    />
    <input type="date" onChange={(e) => onChange("endDate")(e.target.value)} />
    {children}
  </div>
);
ApprovalFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node
};
export default ApprovalFilters;
